import React from 'react'
import { BsShareFill } from 'react-icons/bs'
import Button from './Button'

export default function ShareButton({ title, url }) {
    //     const shareMode = useMemo(() => {
    //     if (navigator.share) return 'api'
    //     var standalone = window.navigator.standalone,
    //         userAgent = window.navigator.userAgent.toLowerCase(),
    //         safari = /safari/.test(userAgent),
    //         ios = /iphone|ipod|ipad/.test(userAgent)

    //     if (ios) {
    //         if (!standalone && safari) {
    //             // Safari
    //         } else if (!standalone && !safari) {
    //             // iOS webview
    //         }
    //     } else {
    //         if (userAgent.includes('wv')) {
    //             // Android webview
    //             return 'intent'
    //         } else {
    //             // Chrome
    //         }
    //     }
    // }, [])

    // const props = {}
    // if (shareMode === 'api')
    //     props.onClick = () => {
    //         if (navigator.share) {
    //             navigator.share({
    //                 title: title,
    //                 url: url
    //             })
    //             return
    //         }
    //     }
    // else
    // props.href = `intent://`
    return (
        <Button
            icon={<BsShareFill className="inline-block" />}
            onClick={() => {
                if (typeof navigator === 'undefined' && 'share' in navigator)
                    navigator.share({
                        title: title,
                        url: url
                    })
            }}
        />
    )
}
